exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-data {\n  position: relative;\n  -ms-flex: 1;\n      flex: 1;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center; }\n  .no-data p {\n    top: calc(50% + 62px);\n    position: absolute; }\n\n.placeholder {\n  -ms-flex-positive: 1;\n      flex-grow: 1; }\n\nrouter-outlet {\n  height: 46px;\n  min-height: 46px; }\n\napp-creep .btn--cross {\n  margin-left: 16px; }\n\napp-operator,\napp-commander,\napp-executor {\n  position: absolute;\n  display: block;\n  height: 34px;\n  margin: 3px auto;\n  filter: grayscale(100%); }\n\napp-operator {\n  width: 49px;\n  top: calc(50% - 11px);\n  left: calc(50% - 72px);\n  transform: rotate(-135deg); }\n\napp-commander {\n  width: 59px;\n  top: calc(50% - 10px);\n  right: calc(50% - 73px);\n  transform: rotate(135deg); }\n\napp-executor {\n  width: 46px;\n  top: calc(50% - 100px); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/power-planner/power-planner/src/app/page-main.module/page-main.component.scss
// module id = ../../../../../src/app/page-main.module/page-main.component.scss
// module chunks = main